import { IntegrationEventType } from '../../../../api/generated/data-contracts';

export const getEventTextFromEnum = (eventType: IntegrationEventType) => {
    switch (eventType) {
        case 'Project':
            return 'Initiative';
        case 'Assignment':
            return 'Assignment';
        case 'Task':
            return 'Task';
        case 'ProjectTeam':
            return 'Project Team';
        case 'Actuals':
            return 'Actuals';
        case 'ResourcesInbound':
            return 'Resource';
        case 'ResourcesOutbound':
            return 'Resource';
        case 'TeamPlannerAllocations':
            return 'Allocations';
        case 'TeamPlannerProjects':
            return 'Projects';
        case 'Calendar':
            return 'Calendar';
        default:
            return 'Unknown event';
    }
};
